import React, { useContext, useRef } from 'react'
import { Button, Text, View, Textarea } from 'oio-react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useCreateNoteExperimental } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import NoteHeaderContainer from '~/components/NoteHeaderContainer'

const TextCreate = ({ onCreate }) => {
   const pageTitleInputRef = useRef(null)
   const { initiative: notebook } = useContext(InitiativeHierarchyContext)
   const { createNote, loading: creating } = useCreateNoteExperimental()

   const handleNoteCreate = async () => {
      const response = await createNote({
         initiativeId: notebook.id,
         title: pageTitleInputRef.current.value,
         content: []
      })

      onCreate(response)
   }

   return (
      <View
         display="flex"
         alignItems="center"
         flexFlow="column"
         width="100%">
         <Helmet title="Note | New" />
         <NoteHeaderContainer>
            <View width="100%[a-b] calc(100% - 180px)[c-f]">
               <Text
                  size="9[a-b] 10[c-f]"
                  letterSpacing="-0.75px"
                  lineHeight="120%"
                  weight="medium">
                  <Textarea
                     ref={pageTitleInputRef}
                     appearance="plain"
                     size="inherit"
                     name="title"
                     placeholder="Title"
                     rows="1"
                     style={{
                        position: 'relative',
                        width: '100%',
                        left: '-2px',
                        color: '#333',
                        backgroundColor: 'transparent',
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                        fontWeight: 'inherit',
                        letterSpacing: 'inherit',
                        resize: 'none'
                     }}
                  />
               </Text>
            </View>
            <View
               display="flex"
               flexFlow="row"
               justifyContent="space-between[a-c] flex-end[d-f]"
               alignItems="center"
               width="100%[a-c] 180px[d-f]">
               <Button
                  width="78px"
                  onClick={handleNoteCreate}
                  color="#47b855"
                  size="xs[a-b] sm[c-f]"
                  mode={creating ? 'loading' : 'normal'}
                  name="Save"
                  rounded
               />
            </View>
         </NoteHeaderContainer>
      </View>
   )
}

TextCreate.propTypes = {
   onCreate: PropTypes.func.isRequired
}

export default TextCreate
